import React, { Component } from "react";
import DropDownPresenter from "./DropDown.presenter";
import { C_Props, C_States } from "./DropDown.type";
class DropDownContainer extends Component<C_Props, C_States> {
  static defaultProps = {
    isShowIcon: true, // mac dinh la show icon
  };
  state = {
    isOpen: !this.props.isClose, // mặc định là mở
    currentIcon: "",
  };

  onToggleDropDown = () => {
    this.setState((prevState) => ({ ...prevState, isOpen: !prevState.isOpen }));
  };

  onChangeCurrentIcon = (value: string) => {
    this.setState((prevState) => ({ ...prevState, currentValue: value }));
  };

  render() {
    return (
      <DropDownPresenter
        title={this.props.title}
        rightSideIcons={this.props.rightSideIcons}
        render={this.props.render(this.state, { onChangeCurrentIcon: this.onChangeCurrentIcon })}
        isShowIcon={this.props.isShowIcon}
        isOpen={this.state.isOpen}
        currentIcon={this.state.currentIcon}
        onToggleDropDown={this.onToggleDropDown}
        onChangeCurrentIcon={this.onChangeCurrentIcon}
      />
    );
  }
}

export default DropDownContainer;
